import React, { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';

// Define props interface for AnimatedTitle component
interface AnimatedTitleProps {
  text: string;
}

// Letter Animation Component
const AnimatedTitle: React.FC<AnimatedTitleProps> = ({ text }) => {
  const [visibleLetters, setVisibleLetters] = useState<number[]>([]);
  const allLetters = text.split('');
  const remainingIndexesRef = useRef<number[]>(Array.from(Array(allLetters.length).keys()));

  useEffect(() => {
    if (remainingIndexesRef.current.length === 0) return;

    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * remainingIndexesRef.current.length);
      const letterIndex = remainingIndexesRef.current[randomIndex];
      remainingIndexesRef.current.splice(randomIndex, 1);
      setVisibleLetters(prev => [...prev, letterIndex]);
      if (remainingIndexesRef.current.length === 0) {
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <Typography
      variant="h1"
      component="h1"
      sx={{
        fontFamily: 'Oswald, sans-serif',
        fontWeight: 600,
        my: 4,
        fontSize: { xs: '3rem', sm: '4rem', md: '6rem' },
        textAlign: 'center',
        color: '#fff',
      }}
    >
      {allLetters.map((letter, index) => (
        <span
          key={index}
          style={{
            opacity: visibleLetters.includes(index) ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out',
            display: letter === ' ' ? 'inline-block' : 'inline',
            width: letter === ' ' ? '0.5em' : 'auto'
          }}
        >
          {letter}
        </span>
      ))}
    </Typography>
  );
};

export default AnimatedTitle;